// Default branding configuration (fallback)
const defaultBranding = {
  locale: 'commerce',
  primaryColor: '#004a59',
  secondaryColor: '#1f2937',
  buttonColor: '#9fe870',
  buttonTextColor: '#004a59',
  loginTitle: 'Login to your portal',
  footerText: 'By continuing, you confirm you have read and agree to the',
  privacyPolicyUrl: 'https://salesdue.com/privacy',
  termsUrl: 'https://salesdue.com',
  showSignUp: false,
  logo: {
    prefix: 'CUSTOMER',
    suffix: 'PORTAL',
    prefixColor: '#1f2937',
    suffixColor: '#ffffff',
    suffixBackgroundColor: '#004a59'
  }
}

// Domain-based branding configuration
// Each domain gets its own complete branding with specified locale
export const domainBranding = {
  // SalesDue Commerce Domains
  'customer.salesdue.com': {
    loginTitle: 'Login to SalesDue'
  },
  'staging.customer.salesdue.com': {
    loginTitle: 'Login to SalesDue (Staging)'
  },
  
  // Modial Commerce Domain
  'customer.modial.co': {
    loginTitle: 'Login to Modial',
    privacyPolicyUrl: 'https://modial.co/privacy',
    termsUrl: 'https://modial.co',
    logo: {
      prefix: 'MODIAL',
      suffix: 'CO'
    }
  },


  'parents.schoolkeeper.io': {
    locale: 'school',
    loginTitle: 'Login to SchoolKeeper',
    privacyPolicyUrl: 'https://schoolkeeper.io/privacy',
    termsUrl: 'https://schoolkeeper.io',
    logo: {
      prefix: 'PARENTS',
      suffix: 'PORTAL'
    }
  },
    'parents.remedialschool.org': {
    locale: 'school',
    loginTitle: 'Login to SchoolKeeper',
    privacyPolicyUrl: 'https://remedialschool.org/privacy',
    termsUrl: 'https://remedialschool.org',
    logo: {
      prefix: 'PARENTS',
      suffix: 'PORTAL'
    }
  },
  'staging.school.salesdue.com': {
    locale: 'school',
    loginTitle: 'Login to SchoolKeeper (Staging)',
    privacyPolicyUrl: 'https://schoolkeeper.io/privacy',
    termsUrl: 'https://schoolkeeper.io',
    logo: {
      prefix: 'PARENTS',
      suffix: 'PORTAL'
    }
  },
  'parents-test.schoolkeeper.io': {
    locale: 'school',
    loginTitle: 'Login to SchoolKeeper (Staging)',
    privacyPolicyUrl: 'https://schoolkeeper.io/privacy',
    termsUrl: 'https://schoolkeeper.io/terms',
    logo: {
      prefix: 'PARENTS',
      suffix: 'PORTAL'
    }
  },
  
  // Estate/Levies Domains
  'residents.estatekeeper.io': {
    locale: 'levies',
    loginTitle: 'Login to EstateKeeper',
    privacyPolicyUrl: 'https://estatekeeper.io/privacy',
    termsUrl: 'https://estatekeeper.io',
    logo: {
      prefix: 'RESIDENTS',
      suffix: 'PORTAL'
    }
  },
  'staging.residents.salesdue.com': {
    locale: 'levies',
    loginTitle: 'Login to EstateKeeper (Staging)',
    privacyPolicyUrl: 'https://estatekeeper.io/privacy',
    termsUrl: 'https://estatekeeper.io',
    logo: {
      prefix: 'RESIDENTS',
      suffix: 'PORTAL'
    }
  },
  
  // Medical Domains
  'patients.modial.health': {
    locale: 'medical',
    loginTitle: 'Login to Modial Health',
    privacyPolicyUrl: 'https://modial.health/privacy',
    termsUrl: 'https://modial.health',
    logo: {
      prefix: 'PATIENTS',
      suffix: 'PORTAL'
    }
  },
  'staging.medical.salesdue.com': {
    locale: 'medical',
    loginTitle: 'Login to Modial Health (Staging)',
    privacyPolicyUrl: 'https://modial.health/privacy',
    termsUrl: 'https://modial.health',
    logo: {
      prefix: 'PATIENTS',
      suffix: 'PORTAL'
    }
  },

  
  // Local Development Domains - use defaults (commerce locale, default colors)
  '127.0.0.1:8080': {},
  '127.0.0.1:4002': {},
  '127.0.0.1:4001': {},
  'localhost:4002': {},
  'localhost:4001': {},
  'portal.salesdue.local:4002': {},
  'portal.salesdue.local:4001': {},
  'retail.salesdue.local:4002': {},
  'retail.salesdue.local:4001': {},
  
  // Local Development with specific locales
  'contractor.salesdue.local:4002': {
    locale: 'contractor',
    logo: { prefix: 'INVOICE', suffix: 'PATROL' }
  },
  'contractor.salesdue.local:4001': {
    locale: 'contractor',
    logo: { prefix: 'INVOICE', suffix: 'PATROL' }
  },
  'sms.salesdue.local:4002': {
    locale: 'fastatext',
    logo: { prefix: 'FASTA', suffix: 'TEXT' }
  },
  'sms.salesdue.local:4001': {
    locale: 'fastatext',
    logo: { prefix: 'FASTA', suffix: 'TEXT' }
  },
  'school.salesdue.local:4002': {
    locale: 'school',
    logo: { prefix: 'PARENTS', suffix: 'PORTAL' }
  },
  'school.salesdue.local:4001': {
    locale: 'school',
    logo: { prefix: 'PARENTS', suffix: 'PORTAL' }
  },
  'levies.salesdue.local:4002': {
    locale: 'levies',
    logo: { prefix: 'RESIDENTS', suffix: 'PORTAL' }
  },
  'levies.salesdue.local:4001': {
    locale: 'levies',
    logo: { prefix: 'RESIDENTS', suffix: 'PORTAL' }
  },
  'medical.salesdue.local:4002': {
    locale: 'medical',
    logo: { prefix: 'PATIENTS', suffix: 'PORTAL' }
  },
  'medical.salesdue.local:4001': {
    locale: 'medical',
    logo: { prefix: 'PATIENTS', suffix: 'PORTAL' }
  },
  'personal.salesdue.local:4002': {
    locale: 'personal',
    logo: { prefix: 'MY', suffix: 'PERSONAL' }
  },
  'personal.salesdue.local:4001': {
    locale: 'personal',
    logo: { prefix: 'MY', suffix: 'PERSONAL' }
  },
}

/**
 * Deep merge two objects
 */
function deepMerge(target, source) {
  const result = Object.assign({}, target)
  
  for (const key in source) {
    if (source[key] && typeof source[key] === 'object' && !Array.isArray(source[key])) {
      result[key] = deepMerge(target[key] || {}, source[key])
    } else {
      result[key] = source[key]
    }
  }
  
  return result
}

/**
 * Get branding configuration based on current domain
 * @param {string} domain - Current domain from location.host
 * @returns {object} Branding configuration with locale
 */
export function getBrandingByDomain(domain) {
  // Check if domain has specific branding configuration
  if (domainBranding[domain]) {
    // Merge domain-specific config with default branding
    return deepMerge(defaultBranding, domainBranding[domain])
  }
  
  // Return default branding if domain not found
  return defaultBranding
}

/**
 * Get locale for current domain
 * @param {string} domain - Current domain from location.host
 * @returns {string} Locale string (e.g., 'commerce', 'medical', 'school')
 */
export function getLocaleByDomain(domain) {
  const branding = getBrandingByDomain(domain)
  return branding.locale || 'commerce'
}



// WEBPACK FOOTER //
// ./src/config/domainBranding.js